// Constants for SchedaEpisodio
export const RELAZIONI = [
  { id: "partner", label: "Partner" },
  { id: "famiglia", label: "Famiglia" },
  { id: "amico", label: "Amico/a" },
  { id: "collega", label: "Collega" },
  { id: "capo", label: "Capo" },
  { id: "cliente", label: "Cliente" },
  { id: "altro", label: "Altro" }
];

export const STATI_EMOTIVI = [
  { id: "calmo", label: "Calmo" },
  { id: "teso", label: "Teso" },
  { id: "ironico", label: "Ironico" },
  { id: "accusatorio", label: "Accusatorio" },
  { id: "evitante", label: "Evitante" },
  { id: "altro", label: "Altro" }
];

export const VOLUMI = [
  { id: "basso", label: "Basso" },
  { id: "medio", label: "Medio" },
  { id: "alto", label: "Alto" }
];

export const RITMI = [
  { id: "lento", label: "Lento" },
  { id: "normale", label: "Normale" },
  { id: "veloce", label: "Veloce" }
];

export const EMOZIONI = [
  { id: "ansia", label: "Ansia", emoji: "\u{1F630}" },
  { id: "rabbia", label: "Rabbia", emoji: "\u{1F620}" },
  { id: "tristezza", label: "Tristezza", emoji: "\u{1F622}" },
  { id: "vergogna", label: "Vergogna", emoji: "\u{1F633}" },
  { id: "colpa", label: "Colpa", emoji: "\u{1F614}" },
  { id: "paura", label: "Paura", emoji: "\u{1F628}" },
  { id: "frustrazione", label: "Frustrazione", emoji: "\u{1F624}" },
  { id: "disagio", label: "Disagio", emoji: "\u{1F623}" }
];

export const STILI_RISPOSTA = [
  { id: "AN", label: "Passiva (AN)", color: "bg-yellow-100 text-yellow-700" },
  { id: "AG", label: "Aggressiva (AG)", color: "bg-red-100 text-red-700" },
  { id: "AS", label: "Assertiva (AS)", color: "bg-green-100 text-green-700" },
  { id: "mista", label: "Mista", color: "bg-gray-100 text-gray-700" }
];

export const INITIAL_FORM = {
  data: new Date().toISOString().split('T')[0],
  luogo: "",
  conChi: "",
  relazione: "",
  relazioneAltro: "",
  tema: "",
  descrizione: "",
  ioDetto: ["", "", ""],
  altroDetto: ["", "", ""],
  ioStatoEmotivo: "",
  ioStatoEmotivoAltro: "",
  ioVolume: "",
  ioRitmo: "",
  ioPostura: "",
  altroStatoEmotivo: "",
  altroStatoEmotivoAltro: "",
  altroVolume: "",
  altroRitmo: "",
  altroPostura: "",
  emozioni: {},
  sensazioniFisiche: "",
  pensieri: ["", "", ""],
  cosaVolevo: "",
  cosaOttenuto: "",
  mioStile: "",
  altroStile: ""
};

export const TOTAL_SECTIONS = 9;
